module.exports = __webpack_public_path__ + "static/media/close.85c2c824.svg";